import { FC } from 'react'
import TSvgProps from './type/svgPropsType'

interface OpenArrowIconProps extends TSvgProps {
  isOpen: boolean
}

const OpenArrowIcon: FC<OpenArrowIconProps> = ({ isOpen, ...props }) => {
  return isOpen ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
    >
      <desc>열림 아이콘</desc>
      <g fill="none" data-name="icon /16/close">
        <path d="M0 0h20v20H0z" data-name="사각형 30330"></path>
        <path
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M16.516 13.276L9.96 6.72l-6.556 6.556"
          data-name="패스 16073"
        ></path>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}
    >
      <desc>닫힘 아이콘</desc>
      <g fill="none" data-name="icon /16/more">
        <path d="M0 0h20v20H0z" data-name="사각형 30330"></path>
        <path
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M3.329 6.573l6.411 6.411 6.411-6.411"
          data-name="패스 16073"
        ></path>
      </g>
    </svg>
  )
}

export default OpenArrowIcon
